// Components/ui
import { Box, Typography } from '@mui/material';
// Types
import { ReactNode } from 'react';

type InputContainerProps = {
  children: ReactNode;
  title: string;
};

const InputContainer = ({ children, title }: InputContainerProps) => {
  return (
    <Box>
      <Typography
        variant="subtitle2"
        sx={{
          mb: 1,
          userSelect: 'none',
        }}
      >
        {title}
      </Typography>
      {children}
    </Box>
  );
};

export default InputContainer;
